import * as React from 'react';

const SvgRoster = props => {
  const { size, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <path d="M15.93 18.54a1 1 0 00-1.3-.55 7.06 7.06 0 01-5.25 0 1 1 0 10-.76 1.85 9 9 0 006.76 0 1 1 0 00.55-1.3zM15.94 5.71A7 7 0 0119 11.5a8.49 8.49 0 01-.05.88 1 1 0 102 .24A8.42 8.42 0 0021 11.5a9 9 0 00-3.93-7.44 1 1 0 10-1.13 1.65zM4.18 13.49a1 1 0 00.87-1.11 8.49 8.49 0 010-.88 7 7 0 013.01-5.79 1 1 0 10-1.13-1.65A9 9 0 003 11.5a8.42 8.42 0 00.07 1.12 1 1 0 001.11.87zM15.67 9.5a.25.25 0 00.2-.09.27.27 0 00.05-.21A4.06 4.06 0 008 9.19a.25.25 0 000 .22.28.28 0 00.19.09z" />
      <circle cx={12} cy={2.5} r={2.5} />
      <path d="M20 20.5a4.06 4.06 0 00-4 3.2.25.25 0 00.24.3h7.46a.29.29 0 00.2-.09.28.28 0 000-.22A4.06 4.06 0 0020 20.5z" />
      <circle cx={20.03} cy={17} r={2.5} />
      <path d="M4 20.5a4.06 4.06 0 00-4 3.2.26.26 0 000 .21.25.25 0 00.3.09h7.45a.25.25 0 00.25-.31 4.07 4.07 0 00-4-3.19z" />
      <circle cx={4.07} cy={17} r={2.5} />
    </svg>
  );
};

export default SvgRoster;
